import React from "react"
import { Text, View } from "react-ame-components"

export class TestsExample extends React.Component {
  render() {
    return (
      <View padding="large">
        <Text>Essa é uma página vazia para vários testes</Text>
      </View>
    )
  }
}
